import apiClient from '../client';

export interface APIResponse<T = any> {
  success: boolean;
  message?: string;
  data?: T;
}

export interface User {
  id: number;
  email: string;
  name: string;
  mobile_number?: string;
  role: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
}

export interface AuthResponse {
  token: string;
  user: User;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export const authService = {
  async checkAuth(): Promise<APIResponse<User>> {
    const response = await apiClient.get('/api/v1/auth/status');
    return response.data;
  },

  async login(credentials: LoginCredentials): Promise<APIResponse<AuthResponse>> {
    const response = await apiClient.post('/api/v1/auth/login', credentials);
    return response.data;
  },

  async logout(): Promise<APIResponse> {
    const response = await apiClient.post('/api/v1/auth/logout');
    return response.data;
  },

  async changePassword(data: ChangePasswordRequest): Promise<APIResponse> {
    const response = await apiClient.post('/api/v1/auth/change-password', data);
    return response.data;
  },
};